import { useMemo } from "react";
import { useHits, useSortBy, useInstantSearch } from "react-instantsearch";
import findOrderByOptions from "@utils/catalog-filters/findOrderByOptions";
import CatalogProduct from "./CatalogProduct";
import NoProductException from "./NoProductException";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

const CatalogGrid = ({ context, onProductRemovedFromUserList }) => {
  const orderByOptions = useMemo(() => findOrderByOptions(), []);

  const { items } = useHits();
  const { status, uiState } = useInstantSearch();
  const { currentRefinement } = useSortBy({ items: orderByOptions });

  const isNoRentedProducts = uiState[mainIndex]?.configure?.filters?.includes(
    "NO_RENTED_PRODUCTS_EXCEPTION",
  );
  const isSearchOnLikedProducts = uiState[mainIndex]?.refinementList?.id?.length;
  const isWishlistEmpty = uiState[mainIndex]?.refinementList?.id?.includes(
    "NO_LIKED_PRODUCTS_EXCEPTION",
  );
  const isUserListEmpty = uiState[mainIndex]?.refinementList?.id?.includes(
    "NO_USERLIST_PRODUCTS_EXCEPTION",
  );
  const isSearchOnLikedProductNoResults =
    items.length === 0 && isSearchOnLikedProducts && !isWishlistEmpty && !isUserListEmpty;

  if (items.length === 0 && ["loading", "stalled"].includes(status)) {
    return (
      <div className="catalog-grid">
        {[...Array(96).keys()].map((i) => (
          <CatalogProduct key={i} />
        ))}
      </div>
    );
  }

  if (isNoRentedProducts || isSearchOnLikedProductNoResults || isWishlistEmpty || isUserListEmpty) {
    return (
      <NoProductException
        isSearchOnLikedProductNoResults={isSearchOnLikedProductNoResults}
        context={context}
      />
    );
  }

  if (items.length === 0 || status === "error") return null;

  return (
    <div className="catalog-grid mb-4">
      {items.map((hit, index) => (
        <CatalogProduct
          key={`${hit.id}-${index}`}
          product={hit}
          context={context}
          indexName={currentRefinement}
          position={index + 1}
          onProductRemovedFromUserList={onProductRemovedFromUserList}
        />
      ))}
    </div>
  );
};

export default CatalogGrid;
